import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 14,
	viewBox: "0 0 14 14",
	width: 14,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m13.3.710001c-.39-.39-1.02-.39-1.41 0l-4.89003 4.879999-4.89-4.889999c-.39-.39-1.02-.39-1.409999 0-.39.389999-.39 1.019999 0 1.409999l4.889999 4.89-4.889999 4.89c-.39.39-.39 1.02 0 1.41.389999.39 1.019999.39 1.409999 0l4.89-4.89 4.89003 4.89c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41l-4.89003-4.89 4.89003-4.89c.38-.38.38-1.02 0-1.399999z",
		fill: "currentColor"
	})
});
export { SvgClose as ReactComponent };
